export const COLORS = {
  darkText: '#131516',
  blue: '#00BFD2',
  lightGray: '#808080',
  gray: '#636363',
  darkGray: '#63666A',
  negative: '#EE5340',
  positive: '#63A817',
  neutral: '#0097a9',
  unavailable: '#B5BBBF',
  tealGreen: '#02818E',
  orangeDark: '#ED7A00',
  orangeBorder: '#EA8F38',
  coldBlue: '#33ABBA',
  textColor: '#676a6c',
  creditBlack: '#052530',
  cashGreen: '#049175',
  emergencyColor: '#CE0B24',
  darkBlue: '#00606A0',

  /* STYLE OVERRIDES */
  white: '#FFFFFF',
  almostWhite: '#DDD',
  gray90: '#E5E5E5',
  extraLightGray: '#D7E0DB',
  mediumGray: '#CCCCCC',
  gbbpDarkBackground: '#344247',
  gbbpPrimary1: '#10C3D5',
  gbbpBorder: '#D8E2DC',
  gbbpHighlight1: '#F2FAFB',
  gbbpBackground: '#F4F3F3',
  gbbpTableRow: '#FAFAFA',
  gbbpTableRowAlt: '#FFFFFF',
  select2Hoverbkg: '#5897FB',
  gbbpTableRowOddWatching: '#E9F1F2',
  gbbpTableRowEvenWatching: '#EEF4F5',
  lightGreyBorder: '#E7EAEC',
  greyBorder: '#D1D3D5',
  orange: '#FFA551',
  boxShadow: '#756075',
  ratingsText: '#64B9C5',
  sidebarBkg: '#1A2022',
  sidebarHeaderBkg: '#0F1315',
  sidebarLinkHover: '#222729',
  black: '#000',
  userProfilePopupBkg: '#232729',
  userProfileSliderBkg: '#2A2D2F',
  userProfilePopupText: '#DBDBDB',
  userProfilePopupSubtitle: '#D9D9D9',
  skyBlue: '#A8E1E5',
  starYellow: '#F6CC1C',
  gasbuddyComponentsBlueBorder: '#55bac6',

  /* Match other components with gasbuddy-react */
  highlightedItemColor: '#e0eff1',
};
